import { getChartOfAccountsTemplateCsv } from "@api/coaTemplate.api";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";
import { useScope } from "@state/scopeContext.lib";

export function useChartOfAccountsTemplateCsvDownload() {
    const { organizationId } = useScope();

    return useFileDownload(async (chartOfAccountsTemplateId: string) => {
        if (!organizationId) {
            return;
        }
        const response = await getChartOfAccountsTemplateCsv({
            organizationId,
            chartOfAccountsTemplateId,
        });
        // The server sets the filename via Content-Disposition; saveBlobResponse
        // prefers that header, so this is only a generic fallback.
        saveBlobResponse(response, "chart-of-accounts.csv");
    });
}
